import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-664d2dff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Order Data by Container")
], -1))
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-bordered table-hover mt-3" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  class: "text-center"
}, "No data available", -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortTable('name')))
              }, "Toggle"),
              _createElementVNode("th", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortTable('name')))
              }, "Container Name"),
              _createElementVNode("th", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortTable('count')))
              }, "Order Count"),
              _createElementVNode("th", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortTable('countPercentage')))
              }, "Order Count (%)"),
              _createElementVNode("th", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortTable('orderLineCount')))
              }, "Order Line Count"),
              _createElementVNode("th", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortTable('orderLineCountPercentage')))
              }, "Order Line Count (%)"),
              _createElementVNode("th", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortTable('volume')))
              }, "Volume (m³)"),
              _createElementVNode("th", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortTable('volumePercentage')))
              }, "Volume (%)")
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedContainers, (container) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: container.name
              }, [
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((container.selected) = $event),
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.recalculatePercentages && _ctx.recalculatePercentages(...args)))
                  }, null, 40, _hoisted_6), [
                    [_vModelCheckbox, container.selected]
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(container.name), 1),
                _createElementVNode("td", null, _toDisplayString(container.count), 1),
                _createElementVNode("td", null, _toDisplayString(container.countPercentage.toFixed(2)) + "%", 1),
                _createElementVNode("td", null, _toDisplayString(container.orderLineCount), 1),
                _createElementVNode("td", null, _toDisplayString(container.orderLineCountPercentage.toFixed(2)) + "%", 1),
                _createElementVNode("td", null, _toDisplayString(container.volume.toFixed(6)), 1),
                _createElementVNode("td", null, _toDisplayString(container.volumePercentage.toFixed(2)) + "%", 1)
              ]))
            }), 128)),
            (_ctx.containers.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}